import React, { Component, Fragment } from 'react'
import { Bar, Doughnut } from 'react-chartjs-2'
import Grid from '@material-ui/core/Grid'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
//import LinearProgress from '@material-ui/core/LinearProgress'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import ListItemText from '@material-ui/core/ListItemText'
import EmailIcon from '@material-ui/icons/Email'
import NotificationsIcon from '@material-ui/icons/Notifications'
import BusinessIcon from '@material-ui/icons/Business'
//import MoreIcon from '@material-ui/icons/More'
import PersonIcon from '@material-ui/icons/Person'

// Comments component
import ListItem from '@material-ui/core/ListItem'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import Avatar from '@material-ui/core/Avatar'

import red from '@material-ui/core/colors/red'
import { Wrapper, StatCard } from '../../components'
import { colors, homeChart } from '../../utils/chart'
import { formatEnquiry, formatComment } from '../../helpers'

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import RegulationsDialog from './RegulationsDialog'

import { statusColors } from '../../utils/colors'
import * as API from '../../utils/api'

const classes = {
  commentItemPrimary: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  commentItemSecondary: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.8125rem',
    fontStyle: 'italic'
  }
};

class Home extends Component {
  state = {
    views: {},
    enquiriesStats: {},
    openRegulationsDialog: true
  };

  componentDidMount () {
    const { accountId } = this.props

    API.getViews(accountId)
      .then((views) => {
        this.setState(() => ({
          views
        }))
      })

    API.getEnquiriesStatistics(accountId)
      .then((enquiriesStats) => {
        this.setState(() => ({
          enquiriesStats
        }))
      })
  }

  handleRegulationsDialogOpen = (event) => {
    this.setState({ openRegulationsDialog: true });
  }

  handleRegulationsDialogClose = () => {
    this.setState({ openRegulationsDialog: false });
  }

  render() {
    const { enquiriesCount, officesCount, statusData, newEnquiriesCount, currentEnquiries, lastComments, regulationsAccepted } = this.props
    const { views, enquiriesStats, openRegulationsDialog } = this.state

    const viewsLabels = Object.keys(views)
    const viewsDatasets = [{
      label: ' Visits',
      ...colors[0],
      borderWidth: 0,
      data: Object.values(views)
    }]
    const viewsData = {
      labels: viewsLabels,
      datasets: viewsDatasets
    }

    const enquiriesLabels = Object.keys(enquiriesStats)
    const enquiriesDatasets = [{
      label: ' Enquiries',
      ...colors[1],
      borderWidth: 0,
      data: Object.values(enquiriesStats)
      }
    ]
    const enquiriesStatsData = {
      labels: enquiriesLabels,
      datasets: enquiriesDatasets
    }

    const statusColor = [statusColors.new, statusColors.confirmed, statusColors.rejected, statusColors.finalised, statusColors.canceled]
    const statusArray = ['New', 'Confirmed', 'Rejected', 'Finalised', 'Canceled']

    return (
      <Wrapper>
        <Grid container spacing={8}>
          <Grid item xs={12} sm={4} md={4}>
            <Link to='/offices'>
              <StatCard
                title="Offices"
                value={officesCount}
                icon={<BusinessIcon />}
                color="#3f51b5"
              />
            </Link>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Link to='/enquiries'>
              <StatCard
                title="Enquiries"
                value={enquiriesCount}
                icon={<EmailIcon />}
                color="#9c27b0"
              />
            </Link>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Link to='/enquiries'>
              <StatCard
                //type="fill"
                title="New enquiries"
                value={newEnquiriesCount}
                icon={<NotificationsIcon />}
                color="#f44336"
              />
            </Link>
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <Card>
              <CardHeader subheader='Visits' />
              <CardContent>
                <Bar
                  data={viewsData}
                  height={homeChart[0].height}
                  options={homeChart[0].options}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card>
              <CardHeader subheader='Enquiries' />
              <CardContent>
                <Bar
                  data={enquiriesStatsData}
                  height={homeChart[1].height}
                  options={homeChart[1].options}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card>
              <CardHeader subheader='Status' />
              <CardContent>
                <Doughnut
                  data={statusData}
                  height={homeChart[2].height}
                  options={homeChart[2].options}
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={12} md={8}>
            <Paper className="table-responsive">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Company</TableCell>
                    <TableCell numeric>Size</TableCell>
                    <TableCell numeric>Commencement date</TableCell>
                    <TableCell numeric>Status</TableCell>
                    {/*<TableCell numeric>Current progress</TableCell>*/}
                  </TableRow>
                </TableHead>
                <TableBody>
                  { currentEnquiries.map(e => {
                    const color = statusColor[e.statusId - 1]

                    return (
                      <TableRow key={e.id}>
                        <TableCell component="th" scope="row">
                          <Link to={`/enquiry/${e.id}`}>
                            {e.name}
                          </Link>
                        </TableCell>
                        <TableCell numeric>
                          {e.numberOfEmployees
                            ? <Fragment>
                                <span style={{ verticalAlign: 'middle' }}>{e.space}</span>
                                <PersonIcon style={{ fontSize: 13, verticalAlign: 'middle' }} />
                              </Fragment>
                            : e.space
                          }
                        </TableCell>
                        <TableCell numeric>{e.commencementDateFormatted}</TableCell>
                        <TableCell numeric style={{ color: color }}>{statusArray[e.statusId-1]}</TableCell>
                        {/*<TableCell numeric>{<LinearProgress variant="determinate" value={e.progress} />}</TableCell>*/}
                      </TableRow>)
                    })
                  }
                </TableBody>
              </Table>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card>
              <CardHeader
                title="Status update"
                //subheader="Last updated 24 mins ago"
                classes={{ title: classes.cardHeader }}
              />
              <Divider />
              <List>
                {typeof lastComments === 'object' && lastComments.map((item, index) => (
                  <ListItem key={index}>
                    {item.userAvatar ? <Avatar alt={item.userName} src={`/static/images/avatars/${item.userAvatar}`} /> : <Avatar style={{backgroundColor: red[500]}}>{item.userInitials}</Avatar>}
                    <ListItemText
                      primary={`${item.userName} (${item.createdOn})`}
                      secondary={item.comment}
                      //classes={{ primary: classes.commentItemPrimary, secondary: classes.commentItemSecondary }}
                    />
                  </ListItem>
                ))}
                {typeof lastComments === 'object' && Object.keys(lastComments).length === 0 && (
                  <ListItem>
                    <ListItemText
                      secondary="No updates yet"
                      //classes={{ secondary: classes.commentItemSecondary }}
                    />
                  </ListItem>
                )}
              </List>
            </Card>

          </Grid>
        </Grid>

        {!regulationsAccepted && (
          <RegulationsDialog open={openRegulationsDialog} handleClose={this.handleRegulationsDialogClose} />)}
      </Wrapper>
    )
  }
}

function mapStateToProps ({ enquiries, offices, authedUser }) {
  const status = {
    'new': Object.values(enquiries).filter((e) => (e.statusId === '1')).length,
    'confirmed': Object.values(enquiries).filter((e) => (e.statusId === '2')).length,
    'rejected': Object.values(enquiries).filter((e) => (e.statusId === '3')).length,
    'finalised': Object.values(enquiries).filter((e) => (e.statusId === '4')).length,
    'canceled': Object.values(enquiries).filter((e) => (e.statusId === '5')).length
  }

  const statusData = {
    labels: [' New', ' Confirmed', ' Rejected', ' Finalised', ' Canceled'],
    datasets: [{
      data: [status.new, status.confirmed, status.rejected, status.finalised, status.canceled],
      backgroundColor: [statusColors.new, statusColors.confirmed, statusColors.rejected, statusColors.finalised, statusColors.canceled]
    }]
  };

  const formattedEnquiries = Object.values(enquiries).filter((e) => (e.commencementDate !== '' && (e.statusId === '1' || e.statusId === '2'))).map((enquiry) => formatEnquiry(enquiry))
  const currentEnquiries = formattedEnquiries.sort((a,b) => a.parsedCommencementDate - b.parsedCommencementDate).slice(0, 6)

  const comments = Object.values(enquiries).filter((e) => e.comments.length > 0).map((e) => e.comments).reduce((a,v) => a.concat(v), [])
  const formattedComments = comments.map((comment) => formatComment(comment)).sort((a,b) => (b.parsedDate - a.parsedDate)).slice(0, 4)

  //console.log(formattedComments)

  return {
    accountId: authedUser.accountId,
    enquiriesCount: Object.keys(enquiries).length,
    officesCount: Object.keys(offices).length,
    statusData: statusData,
    newEnquiriesCount: status.new,
    currentEnquiries: currentEnquiries,
    lastComments: formattedComments,
    regulationsAccepted: authedUser.statuteAccepted
  }
}

export default connect(mapStateToProps)(Home)


// WEBPACK FOOTER //
// ./src/components/Home/Home.js